export default "__VITE_ASSET__aed1f2b9__"